module.exports = __webpack_public_path__ + "static/media/text.618665e6.svg";